export default __webpack_public_path__ + "static/media/ArrowUpLongBlack.ce1888d6.svg";